import { useState } from "react";
import { useForm } from "../useForm";
import Input from "../../controls/Input";

const initialFValues = {
  new_password: "",
  new_password_confirmation: "",
};

export default function ChangePasswordForm(props) {
  const { user, setOpen, onChangePassword } = props;

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false);

  const [validationErrors, setValidationErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!values.new_password) {
      newErrors.new_password = "New password is required";
    }
    if (!values.new_password_confirmation) {
      newErrors.new_password_confirmation = "Password confirmation is required";
    }
    if (
      values.new_password &&
      values.new_password_confirmation &&
      values.new_password !== values.new_password_confirmation
    ) {
      newErrors.new_password_confirmation = "Passwords do not match";
    }

    if (Object.keys(newErrors).length > 0) {
      setValidationErrors(newErrors);
      return;
    }

    onChangePassword(values);
  };

  const handleCancel = () => {
    setOpen({
      childComponent: null,
      open: false,
    });
  };

  return (
    <div>
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
          Change Password for {user.name}
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <Input
                id="new_password"
                label="New Password"
                type="password"
                name="new_password"
                value={values.new_password}
                labelOn={true}
                onChange={handleInputChange}
                error={validationErrors.new_password}
              />
            </div>
            <div>
              <Input
                id="new_password_confirmation"
                label="Confirm New Password"
                type="password"
                name="new_password_confirmation"
                value={values.new_password_confirmation}
                onChange={handleInputChange}
                labelOn={true}
                error={validationErrors.new_password_confirmation}
              />
            </div>
          </div>

          <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
            <button
              type="submit"
              className="inline-flex w-full justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
            >
              Change Password
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
